<template>
  <v-card>
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title>{{ $t('mci-text-1') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light icon @click="closeDialog(false)">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="end">
        <v-col class="shrink">
          <v-btn color="color-grey" depressed right text small @click="closeDialog(false)">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid>
      <v-row justify="center">
        <v-col class="shrink">
          <v-img max-height="200" contain src="/static/images/omaok-contact.png" />
        </v-col>
      </v-row>
      <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col class="text-center">
          <h1 class="text-h1 mt-0">{{ $t('mci-text-1') }}</h1>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="9">
          <div>{{ $t('mci-text-2') }}</div>
          <b v-if="!hasEmail" class="text-lowercase">{{ $t('email') }}</b>
          <b v-if="!hasEmail && !hasPhone">, </b>
          <b v-if="!hasPhone" class="text-lowercase">{{ $t('phoneNr') }}</b>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="9">
          <p>{{ $t('mci-text-3') }} <a @click="closeDialog(true)">{{ $t('menu.profile') }}</a> {{ $t('mci-text-4') }}</p>
          <p>{{ $t('mci-text-5') }}</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn tile color="primary" class="wide-button" @click="closeDialog(true)">
          <span>{{ $t('mci-text-6') }}</span>
        </v-btn>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import moment from 'moment'

  export default {
    computed: {
      debtor: function () {
        return this.$store.getters.debtor
      },
      hasEmail: function () {
        if (this.debtor !== null && this.debtor.contactInformation !== null) {
          return this.debtor.contactInformation.emails.length > 0
        } else {
          return false
        }
      },
      hasPhone: function () {
        if (this.debtor !== null && this.debtor.contactInformation !== null) {
          return this.debtor.contactInformation.phones.length > 0
        } else {
          return false
        }
      }
    },
    methods: {
      closeDialog(moveToProfile) {
        this.$store.commit('setMissingContactInformationQueried', moment())
        if (moveToProfile) {
          this.$router.push('/profile')
          this.$emit('close')
        } else {
          this.$emit('close')
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "mci-text-1": "Päivitäthän yhteystietosi",
  "mci-text-2": "Hei! Huomasimme, että seuraavat yhteystiedot puuttuvat käyttäjätiedoistasi:",
  "mci-text-3": "Ole hyvä ja käy lisäämässä puuttuvat yhteystiedot",
  "mci-text-4": "-sivulla.",
  "mci-text-5": "Kiitos!",
  "mci-text-6": "Lisää puuttuvat tiedot"
  },
  "se": {
  "mci-text-1": "Vänligen uppdatera dina kontaktuppgifter",
  "mci-text-2": "Hej! Vi märkte att följande uppgifter saknas från din användarprofil:",
  "mci-text-3": "I ",
  "mci-text-4": "kan du lägga till de kontaktuppgifter som saknas.",
  "mci-text-5": "Tack!",
  "mci-text-6": "Lägg till den information som saknas"
  },
  "en": {
  "mci-text-1": "Please update your contact details",
  "mci-text-2": "Hi! We noticed that the following information is missing from your user profile:",
  "mci-text-3": "Please add the missing contact details on ",
  "mci-text-4": "page",
  "mci-text-5": "Thank you!",
  "mci-text-6": "Add missing information"
  }
  }
</i18n>
